import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateCountries} from '../containers/Registration/RegistrationForm/actions';
const storageHandler = new StorageHandler();

export function* getCountriesSaga(){
	
	let countries = localStorage.getItem('countries');	
	
	if(!countries)
	{
	  const Network = new NetworkHandler();
		
      try{
          
          const response = yield Network.requestGetAllCountries();
  
          if (!(response instanceof Error)) {
               yield put(
                   updateCountries(response)
                );

				localStorage.setItem('countries', JSON.stringify(response));	              
            } else {
              yield put(
                error({
                  message: 'Unable to countries',
                })
              );
          }
    
      }catch (errorMsg) {
          yield put(
              error({
               message: `Unable to load countries, please try again.${errorMsg}`,
              })
          );
      }
	}
	else
	{

	}
  }
  export default function* countriesSagas() {
    yield takeLatest(ACTIONS.CRYODEX_GET_COUNTRIES, getCountriesSaga);
  }
  
  